import { Component, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { MetaDataService } from '@core/meta-data/meta-data.service';
import { SharedCatalogState } from '@shared/state/catalog/shared-catalog.state';
import { Store } from '@ngxs/store';

@Component({
  selector: 'app-catalog-passport-tab',
  templateUrl: './catalog-passport-tab.component.html',
  styleUrls: ['./catalog-passport-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogPassportTabComponent implements OnInit {

  constructor(
    private store: Store,
    private metaDataService: MetaDataService
  ) {}

  ngOnInit() {
    const catalogInfo = this.store.selectSnapshot(SharedCatalogState.catalogInfo);
    this.metaDataService.updateTitleAfterDataLoading(
      '/opendata/id/passport',
      catalogInfo?.nameVariants?.[0]?.fullName,
      catalogInfo?.accountingObject,
    );
  }
}
